/**
 * Route for `bot-traffic-detection`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BotTrafficDetectionPage } from "../features/bot-traffic-detection/BotTrafficDetectionPage";

export const botTrafficDetectionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/bot-traffic-detection",
	component: BotTrafficDetectionPage,
});

export default botTrafficDetectionRoute;
